import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { useDisableHotkeyScopes } from "components/scrapEyeLabelling/hooks/useDisableHotkeyScopes";
import { EDIT_EVENT_SUB_MODAL_DISABLED_SCOPES } from "../hotkeyScopes";
import { ScrapEyesEvent } from "components/scrapEyeLabelling/types";
import { useTenantTranslation } from "hooks/formatters";
import { useHotkeys } from "react-hotkeys-hook";
import { CommentSection } from "./sections/CommentSection";

interface CommentModalProps {
  open: boolean;
  onClose: () => void;
  event: ScrapEyesEvent;
  onChange: (updates: Partial<ScrapEyesEvent>) => void;
}

export const CommentModal = ({
  open,
  onClose,
  event,
  onChange,
}: CommentModalProps) => {
  const { t } = useTenantTranslation();

  useDisableHotkeyScopes(EDIT_EVENT_SUB_MODAL_DISABLED_SCOPES, open);

  useHotkeys(
    "escape",
    () => {
      onClose();
    },
    {
      enabled: open,
      enableOnFormTags: false,
      preventDefault: true,
    },
    [open, onClose]
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t("comment")}</DialogTitle>
      <DialogContent>
        <CommentSection event={event} onChange={onChange} />
      </DialogContent>
    </Dialog>
  );
};
